// packages/eden-table/src/components/OverflowWrapper/Context.jsx
import { createContext } from "react";
var OverflowWrapperContext = createContext();
var Context_default = OverflowWrapperContext;
export {
  Context_default as default
};
